export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L0_solid_s_01_f_mask.e51b9f15.png";